import {XauditModel} from '../xaudit.model';

export class DoctorArLocationDataModel extends XauditModel {
  DoctorARLocId: string;
  DoctorId: string;
  LOCID: number;
  ARAccountID: string;
  ARSalesAccountID: string;
  ARCheckAccountID: string;
  enumARSystemIntegrationID: string;
  ARSystemIntegrationStart: Date;
  ARSystemIntegrationJSON: string;

  constructor() {
    super();
    this.enumARSystemIntegrationID = '';
  }
}
